import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllActiveRooms = createAsyncThunk(
  "Room/FindAllActiveRoom",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Room/FindAllActiveRoom`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Rooms:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export async function fetchAllActiveRooms() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Room/FindAllActiveRoom`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchRoomDataByUrl(URL: string) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Website/FindByRoomURL`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ RoomURL: URL }),
      next: { revalidate: 30 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

// Track third-party booking redirects
// Called before opening hotel.BookingURL in a new tab
export async function insertBookingReference(RoomID: number, URL: string) {
  let geoData = {};
  try {
    const geoRes = await fetch("https://ipapi.co/json/");
    if (geoRes.ok) {
      const data = await geoRes.json();
      geoData = {
        City: data.city || "",
        State: data.region || "",
        Country: data.country_name || "",
        IP: data.ip || "",
        Pincode: data.postal || "",
        Latitude: data.latitude !== undefined ? data.latitude : null,
        Longitude: data.longitude !== undefined ? data.longitude : null,
      };
    }
  } catch (err) {
    console.error("Error fetching geo details from ipapi:", err);
  }

  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Website/InsertBookingReference`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ RoomID, URL, ...geoData }),
        cache: "no-store",
      },
    );
    const json = await res.json();
    return json;
  } catch (error) {
    console.error("Error inserting booking reference:", error);
    return null;
  }
}
